import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  buildUserSessionEvent,
  pushToDataLayer,
} from "../../utils/analytics/gtm";

const SESSION_FLAG_KEY = "gtm:user_session_start";

const getPersisted = (key) => {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return undefined;
  }
};

const setSessionFlag = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.setItem(SESSION_FLAG_KEY, "1");
  } catch (error) {
    // ignore storage errors (private mode, etc.)
  }
};

const hasSessionFlag = () => {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return Boolean(window.sessionStorage.getItem(SESSION_FLAG_KEY));
  } catch (error) {
    return false;
  }
};

const persistCustomerCode = (customer) => {
  if (!customer?.code || typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem("selectedCustomerCode", customer.code);
  } catch (error) {
    // ignore persistence issues
  }
};

const useUserSessionAnalytics = () => {
  const stakeholder = useSelector((state) => state?.yodaStakeholders?.me);
  const customer = useSelector((state) => state?.yodaCustomer?.customer);

  useEffect(() => {
    if (!stakeholder || hasSessionFlag()) {
      persistCustomerCode(customer);
      return;
    }

    // Se customer non è ancora caricato, aspettiamo: l'effect si rieseguirà quando
    // arriva customer, così account = customer.code è coerente con tutti gli altri eventi.
    if (!customer) {
      return;
    }

    const persistedCustomerId = getPersisted("selectedCustomer");
    const persistedAgentId = getPersisted("selectedAgent");

    const event = buildUserSessionEvent({
      stakeholder,
      customer,
      persistedCustomerId,
      persistedAgentId,
      timestamp: new Date(),
    });

    if (!event) {
      persistCustomerCode(customer);
      return;
    }

    pushToDataLayer(event);
    setSessionFlag();
    persistCustomerCode(customer);
  }, [stakeholder, customer]);
};

export default useUserSessionAnalytics;
